import { RECEIPT_TYPES, RECEIPT_PRESET_TYPE, RECEIPT_OFFSET_TYPES } from '../data/receipt.data';
import { EReceiptAction, EReceiptMemoType, EReceiptRecordType, EReceiptStatus } from '../enums/receipt.enum';

export type ReceiptType = typeof RECEIPT_TYPES[number]['id'];
export type ReceiptMode = string;
export type ReceiptStatus = `${EReceiptStatus}`;

export type ReceiptMemoType = `${EReceiptMemoType}`;
export type ReceiptActionType = `${EReceiptAction}`;
export type ReceiptRecordType = `${EReceiptRecordType}`;


export type ReceiptPresetMode = typeof RECEIPT_PRESET_TYPE[number]['id'];
export type ReceiptOffsetType = typeof RECEIPT_OFFSET_TYPES[number]['id'];

export type ReceiptNavigationDescriptionType<T> = {
  id: T;
  title: string;
  linkPrefix: string | null;
}

export type ReceiptNavigationTypeRecord = Record<ReceiptRecordType, ReceiptNavigationDescriptionType<ReceiptRecordType>>
export type ReceiptOffsetNavigationTypeRecord = Record<ReceiptOffsetType, ReceiptNavigationDescriptionType<ReceiptOffsetType>>

